import { Head, useForm } from '@inertiajs/react'
import { SubmitEvent } from 'react'
import StaffForm, { StaffFormData } from './_form'

interface Staff {
  id: number
  events_worked: string | null
  cashier_experience: string | null
  favored_positions: string | null
  days_staffed: number | null
  staffed_before: boolean | null
  cashiered_before: boolean | null
}

interface Participant {
  id: number
  name: string | null
  location: string | null
  email: string | null
  phone_number: string | null
  instagram: string | null
  youtube: string | null
  flickr: string | null
}

interface EditStaffParticipantProps {
  staff: Staff
  participant: Participant
  errors?: string[]
}

export default function EditStaffParticipant({ staff, participant, errors }: EditStaffParticipantProps) {
  const { data, setData, patch, processing } = useForm<StaffFormData>({
    participant: {
      name: participant.name || '',
      location: participant.location || '',
      email: participant.email || '',
      phone_number: participant.phone_number || '',
      instagram: participant.instagram || '',
      youtube: participant.youtube || '',
      flickr: participant.flickr || ''
    },
    staff: {
      events_worked: staff.events_worked || '',
      cashier_experience: staff.cashier_experience || '',
      favored_positions: staff.favored_positions || '',
      days_staffed: staff.days_staffed || 0,
      staffed_before: staff.staffed_before || false,
      cashiered_before: staff.cashiered_before || false
    }
  })

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault()
    patch('/staff_participant')
  }

  return (
    <>
      <Head title="Edit Staff Profile" />
      <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
        <StaffForm
          data={data}
          setData={setData}
          processing={processing}
          onSubmit={handleSubmit}
          errors={errors}
          title="Edit Staff Profile"
          submitLabel="Update Staff Profile"
        />
      </div>
    </>
  )
}
